import { Link } from "react-router-dom"
import { protectedRoutes, publicRoutes } from "@/app/routes/routeConfig"

export function TestIndexPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">[ADMIN] AGENT CALL</h1>
          <p className="text-lg text-gray-600 mb-2">不動産オーナー管理システム</p>
          <p className="text-sm text-gray-500">開発用ルート一覧</p>
        </div>

        <div className="space-y-8">
          {[...publicRoutes, ...protectedRoutes].map((category) => (
            <div key={category.category} className="bg-white shadow rounded-lg overflow-hidden">
              <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
                <div className="flex items-center">
                  <category.icon className="h-5 w-5 text-gray-500 mr-2" />
                  <h2 className="text-lg font-semibold text-gray-900">{category.category}</h2>
                </div>
              </div>
              <div className="divide-y divide-gray-200">
                {category.routes.map((route) => (
                  <div key={route.path}>
                    <Link
                      to={route.path}
                      className="block px-6 py-4 hover:bg-gray-50 transition-colors"
                    >
                      <h3 className="text-sm font-medium text-gray-900">{route.name}</h3>
                      <p className="text-xs text-gray-400 mt-1 font-mono">{route.path}</p>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
